import { compareString } from "../methods/compareString";
export const LORRY_CATEGORIES = {
    TRUCK: 1,
    LCV: 2,
    CONTAINER: 3,
    HYVA: 4,
    TRAILOR: 5,
    TANKER: 6
};

export enum LORRY_CATEGORIES_ENUM {
    TRUCK = 1,
    LCV,
    CONTAINER,
    HYVA,
    TRAILER,
    TANKER
}

export enum LORRY_BODY_TYPE {
    OPEN,
    CLOSED,
    METAL_STEEL,
    STAINLESS_STEEL,
    OPEN_BODY,
    CLOSE_BODY
}

//Need to be verified
export const LORRY_BODY_TYPE_MAP: any = {
    0: "Open body",
    1: "Closed body",
    2: "Metal steel",
    3: "Stainless steel",
    4: "Open body",
    5: "Closed body"
};

export enum LORRY_CAPACITY_UNIT_TYPES {
    TONNES = "Tonne(s)",
    KILO_LITRES = "Kilo Litre(s)",
    TONNE = "Tonne",
    KILO_LITRE = "Kilo Litre"
}

export const LorryNameToNumberMap = {
    Truck: LORRY_CATEGORIES.TRUCK,
    Trailor: LORRY_CATEGORIES.TRAILOR,
    Container: LORRY_CATEGORIES.CONTAINER,
    LCV: LORRY_CATEGORIES.LCV,
    Hyva: LORRY_CATEGORIES.HYVA,
    Tanker: LORRY_CATEGORIES.TANKER
};

export enum TRUCK_BODY_TYPES {
    OPEN,
    CLOSED
}

/**
 * Internal use only
 */
export enum VehicleBodyOptionsType {
    OPEN = 10,
    CLOSE
}

const NEW_LORRY_TYPES = [
    {
        id: LORRY_CATEGORIES_ENUM.TRUCK,
        label: "Truck",
        iconRight: "Truck-right@3x.png",
        iconRightV2: "Truck-right-v2.png",
        iconLeft: "Truck-left@3x.png",
        fullIconRight: "lorry-icons/v2/Truck.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.CONTAINER,
        label: "Container",
        iconRight: "Container-right@3x.png",
        iconRightV2: "Container-right-v2.png",
        iconLeft: "Container-left@3x.png",
        fullIconRight: "lorry-icons/v2/Container.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.CLOSE]
    },
    {
        id: LORRY_CATEGORIES_ENUM.TRAILER,
        label: "Trailer",
        iconRight: "Trailor-right@3x.png",
        iconRightV2: "Trailor-right-v2.png",
        iconLeft: "Trailor-left@3x.png",
        fullIconRight: "lorry-icons/v2/Trailer.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.LCV,
        label: "LCV",
        iconRight: "LCV-right@3x.png",
        iconRightV2: "LCV-right-v2.png",
        iconLeft: "LCV-left@3x.png",
        fullIconRight: "lorry-icons/v2/LCV.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN, VehicleBodyOptionsType.CLOSE]
    },
    {
        id: LORRY_CATEGORIES_ENUM.HYVA,
        label: "Hyva",
        iconRight: "Hyva-right@3x.png",
        iconRightV2: "Hyva-right-v2.png",
        iconLeft: "Hyva-left@3x.png",
        fullIconRight: "lorry-icons/v2/Hyva.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.TANKER,
        label: "Tanker",
        iconRight: "Tanker-right@3x.png",
        iconRightV2: "Tanker-right-v2.png",
        iconLeft: "Tanker-left@3x.png",
        fullIconRight: "lorry-icons/v2/Tanker.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.KILO_LITRES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.KILO_LITRE,
        unitShort: "KL",
        bodyType: [VehicleBodyOptionsType.CLOSE]
    }
];

const VEHICLE_LIST = {
    LOAD_POST: [] as VehicleInfo[],
    LORRY_POST: [] as VehicleInfo[]
};

export const ALLOWED_LORRY_CATEGORY_IDS = [
    LORRY_CATEGORIES_ENUM.TRUCK,
    LORRY_CATEGORIES_ENUM.LCV,
    LORRY_CATEGORIES_ENUM.CONTAINER
] as const;

export const getAllowedVehicleList = (
    entityType: "load" | "lorry",
    option?: {
        srcList?: VehicleInfo[];
    }
) => {
    const listToFilter =
        (option?.srcList?.length ? option.srcList : undefined) ||
        (entityType === "load" ? VEHICLE_LIST.LOAD_POST : VEHICLE_LIST.LORRY_POST);

    return listToFilter.filter((lorry) => ALLOWED_LORRY_CATEGORY_IDS.some((id) => id === lorry.id));
};

const DefaultMinMax = { min: 0, max: 0 };

export type VehicleListKey = keyof typeof VEHICLE_LIST;

export const NEW_LORRY_CAPACITY: Record<VehicleListKey, CapacityMinMax> = {
    LOAD_POST: DefaultMinMax,
    LORRY_POST: DefaultMinMax
};

function calcCapacity(list: VehicleInfo[]): CapacityMinMax {
    return list.length
        ? list.reduce<CapacityMinMax>(
              (range, lorry) => ({
                  min: Math.min(range.min, lorry.capacity.min),
                  max: Math.max(range.max, lorry.capacity.max)
              }),
              { min: Infinity, max: -Infinity }
          )
        : DefaultMinMax;
}

const emptyLorryTypeBodyObject = Object.values(LORRY_CATEGORIES_ENUM)
    .filter((v) => typeof v === "number")
    .reduce((acc, key) => {
        acc[key as LORRY_CATEGORIES_ENUM] = {};
        return acc;
    }, {} as Record<LORRY_CATEGORIES_ENUM, {}>);

export const VehicleTypeBodyTypeMap: Record<
    "load" | "lorry",
    Record<LORRY_CATEGORIES_ENUM, Partial<Record<number, string>>>
> = {
    load: emptyLorryTypeBodyObject,
    lorry: emptyLorryTypeBodyObject
};

function mapLorryListIntoBodyMap(list: VehicleInfo[]) {
    return list.reduce((acc, lorryInfo) => {
        const { id, bodyOptions } = lorryInfo;
        acc[id] = bodyOptions?.reduce((bodyAcc, bodyOption) => {
            bodyAcc[bodyOption.id] = bodyOption.name;
            return bodyAcc;
        }, {} as Record<string, string>);
        return acc;
    }, {} as typeof VehicleTypeBodyTypeMap["load"]);
}

export function generateLorryList(listForLoadPost: RemoteVehicleInfo[], listForLorryPost: RemoteVehicleInfo[]) {
    const transformMethod = (lorry: RemoteVehicleInfo): VehicleInfo => {
        let min = Infinity;
        let max = -Infinity;

        // Collect min/max from tyre_capacity
        if (lorry.tyre_capacity) {
            for (const t of lorry.tyre_capacity) {
                min = Math.min(min, t.min);
                max = Math.max(max, t.max);
            }
        }

        // Collect min/max from feet_capacity
        if (lorry.feet_capacity) {
            for (const f of lorry.feet_capacity) {
                min = Math.min(min, f.min);
                max = Math.max(max, f.max);
            }
        }

        // If nothing found, fallback to 0
        if (min === Infinity) min = 0;
        if (max === -Infinity) max = 0;

        const bodyOptions =
            lorry.body?.map((item) => ({
                id: item.id,
                name: item.name
            })) || [];

        const tyreOptions =
            lorry.tyres?.map((item) => ({
                count: item.count,
                text: item.text,
                label: `${item.count} ${item.text}`
            })) || [];
        const tyreWithCapacity =
            lorry.tyre_capacity?.map((item) => ({
                min: item.min,
                max: item.max,
                tyreCount: item.tyres_count
            })) || [];
        const feetOptions =
            lorry.feet?.map((item, ix) => ({
                id: ix + 1,
                label: `${item.size} ${item.type}`,
                size: item.size,
                sizeType: item.type
            })) || [];
        const feetWithCapacity =
            lorry.feet_capacity?.map((item) => ({
                size: item.size,
                sizeType: item.type,
                min: item.min,
                max: item.max
            })) || [];
        const feetWithTyres =
            lorry.feet_tyre?.map((item) => ({
                tyreCount: item?.tyres_count,
                feet: item?.feet
            })) || [];

        return {
            ...NEW_LORRY_TYPES.find((lr) => lr.id === lorry?.id),
            remoteInfo: lorry,
            capacity: { min, max },
            capacityText: `${min}-${max} ${lorry.capacity_unit}`,
            bodyOptions,
            tyreOptions,
            tyreWithCapacity,
            feetOptions,
            feetWithCapacity,
            feetWithTyres,
            getTyreOptionsByCapacity(capacity: number): VehicleInfo["tyreOptions"] {
                const validCapacities = tyreWithCapacity.filter((c) => capacity >= c.min && capacity <= c.max);
                return tyreOptions.filter((t) => validCapacities.find((c) => c.tyreCount === t.count));
            },
            getSizeOptionsByCapacity(capacity: number): VehicleInfo["feetOptions"] {
                const validCapacities = feetWithCapacity.filter((c) => capacity >= c.min && capacity <= c.max);
                return feetOptions.filter((t) =>
                    validCapacities.find((c) => c.size === t.size && c.sizeType === t.sizeType)
                );
            },
            getSizeOptionsByTyre(tyres: number): VehicleInfo["feetOptions"] {
                const validSizeList = feetWithTyres.find((item) => item.tyreCount === tyres)?.feet || [];
                return feetOptions.filter((t) => validSizeList.find((c) => c.size === t.size && c.type === t.sizeType));
            }
        } as VehicleInfo;
    };
    const LOAD_POST_LIST = listForLoadPost.map(transformMethod);
    const LORRY_POST_LIST = listForLorryPost.map(transformMethod);

    return {
        LIST: {
            LOAD_POST: LOAD_POST_LIST,
            LORRY_POST: LORRY_POST_LIST
        } as typeof VEHICLE_LIST,
        ALLOWED_CAPACITY: {
            LOAD_POST: calcCapacity(
                getAllowedVehicleList("load", {
                    srcList: LOAD_POST_LIST
                })
            ),
            LORRY_POST: calcCapacity(
                getAllowedVehicleList("lorry", {
                    srcList: LORRY_POST_LIST
                })
            )
        } as typeof NEW_LORRY_CAPACITY,
        BODY_MAP: {
            load: mapLorryListIntoBodyMap(LOAD_POST_LIST),
            lorry: mapLorryListIntoBodyMap(LORRY_POST_LIST)
        } as typeof VehicleTypeBodyTypeMap
    };
}

export function initLorryList(listForLoadPost: RemoteVehicleInfo[], listForLorryPost: RemoteVehicleInfo[]) {
    const listMeta = generateLorryList(listForLoadPost, listForLorryPost);
    VEHICLE_LIST["LOAD_POST"] = listMeta.LIST.LOAD_POST;
    VEHICLE_LIST["LORRY_POST"] = listMeta.LIST.LORRY_POST;

    VehicleTypeBodyTypeMap["load"] = listMeta?.BODY_MAP?.load;
    VehicleTypeBodyTypeMap["lorry"] = listMeta?.BODY_MAP?.lorry;

    NEW_LORRY_CAPACITY["LOAD_POST"] = listMeta?.ALLOWED_CAPACITY?.LOAD_POST;
    NEW_LORRY_CAPACITY["LORRY_POST"] = listMeta?.ALLOWED_CAPACITY?.LORRY_POST;
}

export const getLorryDetailsByType = (type?: LORRY_CATEGORIES_ENUM) => {
    return NEW_LORRY_TYPES.find((lorry) => lorry.id === type);
};

export const getLorryDetailsByName = (label?: string) => {
    return NEW_LORRY_TYPES.find((lorry) => !!label && compareString(label, lorry?.label));
};

export const getVehicleInfoByLorryType = (
    type: LORRY_CATEGORIES_ENUM,
    ...args: Parameters<typeof getAllowedVehicleList>
) => {
    return getAllowedVehicleList(...args).find((lorry) => lorry.id === type);
};

export const deriveVehicleBodyFilterValue = (type: LORRY_CATEGORIES_ENUM, bodyType?: number) => {
    const bodyOption = getLorryDetailsByType(type)?.bodyType;
    let result: number | null = null;

    if (bodyOption?.length === 1) {
        result = bodyOption[0];
    } else {
        if (type === LORRY_CATEGORIES_ENUM.LCV && Number.isInteger(bodyType)) {
            if (bodyType === LORRY_BODY_TYPE.OPEN_BODY) {
                result = VehicleBodyOptionsType.OPEN;
            } else if (bodyType === LORRY_BODY_TYPE.CLOSE_BODY) {
                result = VehicleBodyOptionsType.CLOSE;
            }
        }
    }
    return result;
};

interface IBodyOption {
    id: number;
    name: string;
}

interface IFeetOption {
    id: number;
    size: number;
    sizeType: string;
    label: string;
}
interface ITyreOption {
    count: number;
    text: string;
    label: string;
}
interface ITyreWithCapcityOption extends CapacityMinMax {
    tyreCount: number;
}
interface IFeetWithCapcityOption extends Pick<IFeetOption, "size" | "sizeType">, CapacityMinMax {}

interface IFeetWithTyreOption {
    tyreCount: number;
    feet: Foot[];
}

export type VehicleInfo = typeof NEW_LORRY_TYPES[number] & {
    capacity: CapacityMinMax;
    capacityText: string;
    remoteInfo: RemoteVehicleInfo;
    bodyOptions: IBodyOption[];
    feetOptions: IFeetOption[];
    tyreOptions: ITyreOption[];
    tyreWithCapacity: ITyreWithCapcityOption[];
    feetWithCapacity: IFeetWithCapcityOption[];
    feetWithTyres: IFeetWithTyreOption[];
    getTyreOptionsByCapacity: (capacity: number) => VehicleInfo["tyreOptions"];
    getSizeOptionsByCapacity: (capacity: number) => VehicleInfo["feetOptions"];
    getSizeOptionsByTyre: (tyres: number) => VehicleInfo["feetOptions"];
};

export interface RemoteVehicleInfo {
    id: number;
    name: string;
    capacity_unit: string;
    body?: Body[];
    tyres?: Tyre[];
    feet?: Foot[];
    tyre_capacity?: TyreCapacity[];
    feet_capacity?: FeetCapacity[];
    feet_tyre?: FeetTyre[];
}

export interface CapacityMinMax {
    min: number;
    max: number;
}

interface Body {
    id: number;
    name: string;
}

interface Foot {
    size: number;
    type: string;
}

interface FeetCapacity extends CapacityMinMax, Foot {}

interface FeetTyre {
    tyres_count: number;
    feet: Foot[];
}

interface TyreCapacity extends CapacityMinMax {
    tyres_count: number;
}

interface Tyre {
    count: number;
    text: "Tyres";
}
